<template>
  <div class="app-container">
    <div class="card">
      <el-form ref="form" :model="queryParams" :inline="true">
        <el-form-item label="企业名称：">
          <el-input
            v-model="queryParams.enterprise"
            placeholder="请输入企业名称"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="证件编号：">
          <el-input
            v-model="queryParams.certificateNumber"
            placeholder="请输入证件编号"
            clearable
          />
        </el-form-item>
        <!-- <el-form-item label="状态：">
          <el-select
            v-model="queryParams.status"
            placeholder="请选择推送状态"
            clearable
          >
            <el-option label="成功" value="1"></el-option>
            <el-option label="失败" value="2"></el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item label="最早推送时间：">
          <el-date-picker
            v-model="queryParams.datelist"
            type="datetimerange"
            value-format="yyyy-MM-dd HH:mm:ss"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :default-time="['00:00:00', '23:59:59']"
            unlink-panels
            clearable
            @change="handleQuery"
          />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="handleQuery">
            搜 索
          </el-button>
          <el-button icon="el-icon-delete" @click="handleReset">
            重 置
          </el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="mainContainer">
      <!-- tab切换 -->
      <div class="toponsd">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="进行中" name="one"></el-tab-pane>
          <el-tab-pane label="已成功" name="two"></el-tab-pane>
          <el-tab-pane label="已重推" name="three"></el-tab-pane>
          <el-tab-pane name="four">
            <span slot="label" class="fail-tab-label">
              已失败
              <em v-if="failurecount > 0" class="fail-tab-badge">
                {{ failurecount > 99 ? "99+" : failurecount }}
              </em>
            </span>
          </el-tab-pane>
        </el-tabs>
      </div>
      <!-- 列表 -->
      <div class="table-container">
        <el-table v-loading="loading" :data="tableData" border height="100%">
          <el-table-column prop="id" label="推送事件ID" align="center" fixed />
          <el-table-column prop="pushType" label="推送类型" align="center">
            <template slot-scope="{ row }">
              {{ getPushTypeLabel(row.pushType) }}
            </template>
          </el-table-column>
          <el-table-column
            prop="customerId"
            label="集团客户编号"
            align="center"
          />
          <el-table-column prop="enterprise" label="企业名称" align="center" />
          <el-table-column
            prop="certificateType"
            label="证件类型"
            align="center"
          >
            <template slot-scope="{ row }">
              {{ getCertificateTypeLabel(row.certificateType) }}
            </template>
          </el-table-column>
          <el-table-column
            prop="certificateNumber"
            label="证件编号"
            align="center"
          />
          <el-table-column
            prop="createTime"
            label="最早推送时间"
            align="center"
          />
          <el-table-column label="ERP推送状态" align="center">
            <template slot-scope="{ row }">
              <el-tooltip
                v-if="row.erpPushStatus == 2"
                effect="dark"
                :content="getFailReason(row, 'erpPush')"
                placement="top"
              >
                <span class="status-cell">
                  <span
                    class="status-icon"
                    :class="getStatusClass(row.erpPushStatus)"
                  >
                    <i :class="getStatusIcon(row.erpPushStatus)"></i>
                  </span>
                  <span>{{ getPushStatusLabel(row.erpPushStatus) }}</span>
                  <span class="status-reason-icon">?</span>
                </span>
              </el-tooltip>
              <span v-else class="status-cell">
                <span
                  class="status-icon"
                  :class="getStatusClass(row.erpPushStatus)"
                >
                  <i :class="getStatusIcon(row.erpPushStatus)"></i>
                </span>
                <span>{{ getPushStatusLabel(row.erpPushStatus) }}</span>
              </span>
              <div class="status-time" v-if="row.erpPushTime">
                {{ row.erpPushTime }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="内码接收状态" align="center">
            <template slot-scope="{ row }">
              <el-tooltip
                v-if="row.erpCodeReceiveStatus == 2"
                effect="dark"
                :content="getFailReason(row, 'erpCodeReceive')"
                placement="top"
              >
                <span class="status-cell">
                  <span
                    class="status-icon"
                    :class="getStatusClass(row.erpCodeReceiveStatus)"
                  >
                    <i :class="getStatusIcon(row.erpCodeReceiveStatus)"></i>
                  </span>
                  <span>{{ getPushStatusLabel(row.erpCodeReceiveStatus) }}</span>
                  <span class="status-reason-icon">?</span>
                </span>
              </el-tooltip>
              <span v-else class="status-cell">
                <span
                  class="status-icon"
                  :class="getStatusClass(row.erpCodeReceiveStatus)"
                >
                  <i :class="getStatusIcon(row.erpCodeReceiveStatus)"></i>
                </span>
                <span>{{ getPushStatusLabel(row.erpCodeReceiveStatus) }}</span>
              </span>
              <div class="status-time" v-if="row.erpCodeReceiveTime">
                {{ row.erpCodeReceiveTime }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="B2B推送状态" align="center">
            <template slot-scope="{ row }">
              <el-tooltip
                v-if="row.b2bPushStatus == 2"
                effect="dark"
                :content="getFailReason(row, 'b2bPush')"
                placement="top"
              >
                <span class="status-cell">
                  <span
                    class="status-icon"
                    :class="getStatusClass(row.b2bPushStatus)"
                  >
                    <i :class="getStatusIcon(row.b2bPushStatus)"></i>
                  </span>
                  <span>{{ getPushStatusLabel(row.b2bPushStatus) }}</span>
                  <span class="status-reason-icon">?</span>
                </span>
              </el-tooltip>
              <span v-else class="status-cell">
                <span
                  class="status-icon"
                  :class="getStatusClass(row.b2bPushStatus)"
                >
                  <i :class="getStatusIcon(row.b2bPushStatus)"></i>
                </span>
                <span>{{ getPushStatusLabel(row.b2bPushStatus) }}</span>
              </span>
              <div class="status-time" v-if="row.b2bPushTime">
                {{ row.b2bPushTime }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="其他推送状态" align="center">
            <template slot-scope="{ row }">
              <el-tooltip
                v-if="row.otherPushStatus == 2"
                effect="dark"
                :content="getFailReason(row, 'otherPush')"
                placement="top"
              >
                <span class="status-cell">
                  <span
                    class="status-icon"
                    :class="getStatusClass(row.otherPushStatus)"
                  >
                    <i :class="getStatusIcon(row.otherPushStatus)"></i>
                  </span>
                  <span>{{ getPushStatusLabel(row.otherPushStatus) }}</span>
                  <span class="status-reason-icon">?</span>
                </span>
              </el-tooltip>
              <span v-else class="status-cell">
                <span
                  class="status-icon"
                  :class="getStatusClass(row.otherPushStatus)"
                >
                  <i :class="getStatusIcon(row.otherPushStatus)"></i>
                </span>
                <span>{{ getPushStatusLabel(row.otherPushStatus) }}</span>
              </span>
              <div class="status-time" v-if="row.otherPushTime">
                {{ row.otherPushTime }}
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="overallStatus" label="状态" align="center">
            <template slot-scope="{ row }">
              {{ getOverallStatusLabel(row.overallStatus) }}
            </template>
          </el-table-column>
          <el-table-column
            label="操作"
            width="100"
            align="center"
            fixed="right"
          >
            <template slot-scope="{ row }">
              <span
                v-if="row.overallStatus == 3"
                class="btsed"
                @click="openResendDialog(row)"
                >重新推送</span
              >
              <span v-else>-</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <pagination
        v-show="total > 0"
        :total="total"
        :page.sync="queryParams.currPage"
        :limit.sync="queryParams.pageSize"
        @pagination="getList"
      />
    </div>

    <el-dialog
      title="重新推送"
      :visible.sync="resendDialogVisible"
      width="520px"
      :close-on-click-modal="false"
    >
      <div class="resend-content">
        <span class="el-icon-warning resend-icon"></span>
        <div class="resend-text">
          <div class="resend-title">确认重新推送资料？</div>
          <div class="resend-list">
            <div>1. 重新推送仅会提交推送失败的任务</div>
            <div>2. 重新推送的资料为当前客户已审核通过的最新资料</div>
            <div>3. 重新推送后，将会再次生成一个新的推送记录</div>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeResendDialog">取 消</el-button>
        <el-button
          type="primary"
          :loading="resendLoading"
          @click="confirmResend"
        >
          确 定
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getPushRecord, //推送记录-列表
  retrySendQualification, //推送记录-重新推送
} from "@/api/appApi/appapi.js";
export default {
  name: "",
  data() {
    return {
      activeName: "one", //tab状态
      queryParams: {
        currPage: 1, // 页码
        pageSize: 10, //每页大小
        overallStatus: 1, // 推送类型(1:进行中, 2:已成功, 3:已失败, 4:已重推)
        enterprise: "", //企业名称
        certificateNumber: "", //证件编号
        // status: "", //推送状态(1:成功, 2:失败)
        datelist: [], //最早推送时间
        pushTimeStart: "", //开始时间
        pushTimeEnd: "", //结束时间
      },
      total: 0,
      failurecount: 0, //失败数量
      loading: false,
      tableData: [], //列表

      resendDialogVisible: false,
      resendLoading: false,
      resendRow: null,
    };
  },

  created() {
    if (this.$route.query) {
      console.log(this.$route.query, "this.$route.query");
    }
    this.getList();
  },
  methods: {
    //序号
    indexMethod(index) {
      index + (this.queryParams.currPage - 1) * this.queryParams.pageSize + 1;
    },
    //查询按钮操作
    handleQuery() {
      this.queryParams.currPage = 1;
      this.getList();
    },
    /** 查询列表数据 */
    async getList() {
      if (this.queryParams.datelist && this.queryParams.datelist.length > 0) {
        this.queryParams.pushTimeStart = this.queryParams.datelist[0];
        this.queryParams.pushTimeEnd = this.queryParams.datelist[1];
      } else {
        this.queryParams.pushTimeStart = "";
        this.queryParams.pushTimeEnd = "";
      }
      let params = { ...this.queryParams };
      delete params.datelist;
      this.loading = true;
      let res = await getPushRecord(params);
      this.loading = false;
      if (res.code == "000000") {
        this.tableData = res.content.list;
        this.total = res.content.totalRecords;
        const extra = Array.isArray(res.content.extraData)
          ? res.content.extraData
          : [];
        const failItem = extra.find(
          (it) => Number(it && it.overallStatus) === 3
        );
        this.failurecount = failItem && failItem.count ? failItem.count : 0;
      }
    },

    // 重置
    handleReset() {
      Object.assign(this.queryParams, this.$options.data().queryParams);
      this.getList();
    },
    //切换tab状态
    async handleClick() {
      this.queryParams.currPage = 1;
      if (this.activeName == "one") {
        this.queryParams.overallStatus = 1;
      } else if (this.activeName == "two") {
        this.queryParams.overallStatus = 2;
      } else if (this.activeName == "three") {
        this.queryParams.overallStatus = 4;
      } else if (this.activeName == "four") {
        this.queryParams.overallStatus = 3;
      }
      await this.getList();
    },
    getPushTypeLabel(val) {
      const n = Number(val);
      if (n === 1) return "资质更新";
      if (n === 2) return "手动推送";
      return "-";
    },
    getCertificateTypeLabel(val) {
      const n = Number(val);
      if (n === 1) return "营业执照";
      if (n === 2) return "医疗执业许可证";
      return "-";
    },
    getOverallStatusLabel(val) {
      const n = Number(val);
      if (n === 1) return "进行中";
      if (n === 2) return "已成功";
      if (n === 3) return "已失败";
      if (n === 4) return "已重推";
      return "-";
    },
    getPushStatusLabel(val) {
      const n = Number(val);
      if (n === 1) return "成功";
      if (n === 2) return "失败";
      if (n === 3) return "等待";
      return "-";
    },
    getStatusIcon(val) {
      const n = Number(val);
      if (n === 1) return "el-icon-circle-check";
      if (n === 2) return "el-icon-circle-close";
      if (n === 3) return "el-icon-time";
      return "el-icon-minus";
    },
    getStatusClass(val) {
      const n = Number(val);
      if (n === 1) return "is-success";
      if (n === 2) return "is-failed";
      if (n === 3) return "is-waiting";
      return "is-empty";
    },
    getFailReason(row, type) {
      if (!row) return "失败原因暂无";
      const detailKey = `${type}Detail`;
      const detail = row[detailKey];
      if (detail !== null && detail !== undefined && String(detail).trim() !== "") {
        return String(detail);
      }
      const remark = row.remark;
      if (remark !== null && remark !== undefined && String(remark).trim() !== "") {
        return String(remark);
      }
      return "失败原因暂无";
    },
    openResendDialog(row) {
      this.resendRow = row;
      this.resendDialogVisible = true;
    },
    closeResendDialog() {
      this.resendDialogVisible = false;
      this.resendLoading = false;
      this.resendRow = null;
    },
    async confirmResend() {
      if (!this.resendRow) return;
      this.resendLoading = true;
      let data = {
        id: this.resendRow.id,
      };
      let res = await retrySendQualification(data);
      this.resendLoading = false;
      if (res.code == "000000") {
        this.$message.success("重新推送成功");
        this.getList();
        this.closeResendDialog();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/.el-tabs__nav-wrap::after {
  background-color: #dfe4ed;
}
.toponsd {
  margin-left: 10px;
  position: relative;
  flex-shrink: 0;

  /* 仅作 tab 切换，隐藏空内容区，避免多余空白条 */
  /deep/ .el-tabs__content {
    display: none;
  }

  /deep/ .el-tabs__header {
    margin-bottom: 12px;
  }
}
/* 已失败 tab 角标：与文字同行展示，避免被 tabs 容器裁剪错位 */
.fail-tab-label {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}
.fail-tab-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 18px;
  height: 18px;
  padding: 0 6px;
  border-radius: 9px;
  background-color: #f56c6c;
  color: #fff;
  font-style: normal;
  font-size: 12px;
  line-height: 1;
  box-sizing: border-box;
  white-space: nowrap;
}
.status-cell {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}
.status-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  font-size: 14px;
}
.status-icon.is-success {
  color: #67c23a;
}
.status-icon.is-failed {
  color: #f56c6c;
}
.status-icon.is-waiting {
  color: #e6a23c;
}
.status-icon.is-empty {
  color: #c0c4cc;
}
.status-time {
  margin-top: 2px;
  font-size: 12px;
  color: #909399;
  line-height: 14px;
}
.status-reason-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 14px;
  height: 14px;
  margin-left: 6px;
  border: 1px solid #c0c4cc;
  border-radius: 50%;
  color: #c0c4cc;
  font-size: 12px;
  line-height: 12px;
}
.resend-content {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 10px 0;
}
.resend-icon {
  font-size: 20px;
  color: #e6a23c;
  flex-shrink: 0;
  margin-top: 2px;
}
.resend-title {
  font-weight: bold;
  margin-bottom: 8px;
}
.resend-list {
  color: #606266;
  line-height: 22px;
}
</style>
